import { render, staticRenderFns } from "./ManageRecommend.vue?vue&type=template&id=753e4b3e&scoped=true"
import script from "./ManageRecommend.vue?vue&type=script&lang=js"
export * from "./ManageRecommend.vue?vue&type=script&lang=js"
import style0 from "./ManageRecommend.vue?vue&type=style&index=0&id=753e4b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753e4b3e",
  null
  
)

export default component.exports